import formatters from '../../utils/formatters';
/**
 * Returns a tick position for the given tick value
 */
export default function getTickFormatter(scale) {
  // Broaden type before using 'xxx' in s as typeguard.
  const s = scale;
  // For point or band scales,
  // have to add offset to make the tick centered.
  if (scale.domain()[0] instanceof Date || scale.domain()[1] instanceof Date) return formatters.multiTimeFormat;else if ('tickFormat' in s) {
    return formatters.formatNumberAbbreviated;
  }
  return String;
}